export default "__VITE_ASSET__C8Z06nzQ__"